module.exports = __webpack_public_path__ + "prod/1.2.3/img/balance.10e6a50c.svg";